import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Marketplace from './pages/Marketplace';
import { I18nProvider } from './i18n';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <Routes>
          <Route path="/" element={<Marketplace />} />
          <Route path="/restaurant/:slug" element={<Home />} />
        </Routes>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;